module.exports = __webpack_public_path__ + "static/beauty-appointment-section-code-dd015274db93293a1d87413cf3925e18.png";